import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateProfileMutationVariables = Types.Exact<{
  type: Types.AccountsUserType;
  name: Types.Scalars['String']['input'];
  quiz: ReadonlyArray<Types.AccountsQuizItemInput> | Types.AccountsQuizItemInput;
  budget: Types.Scalars['Int']['input'];
}>;


export type CreateProfileMutationPage = { readonly __typename?: 'RootMutationType', readonly updateUserType: { readonly __typename?: 'AccountsUser', readonly id: string }, readonly createProfile: { readonly __typename?: 'AccountsProfile', readonly id: string }, readonly updateBudget: { readonly __typename?: 'AccountsUser', readonly id: string } };

export type JoinCompanyMutationVariables = Types.Exact<{
  uuid: Types.Scalars['String']['input'];
}>;


export type JoinCompanyMutationPage = { readonly __typename?: 'RootMutationType', readonly createFreeSubscription: boolean, readonly setWizardFinished: { readonly __typename?: 'AccountsUser', readonly id: string }, readonly joinCompany: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly provider: Types.OauthProvider }> } };


export const CreateProfileDocument = gql`
    mutation CreateProfile($type: AccountsUserType!, $name: String!, $quiz: [AccountsQuizItemInput!]!, $budget: Int!) {
  updateUserType(type: $type) {
    id
  }
  createProfile(name: $name, quiz: $quiz) {
    id
  }
  updateBudget(budget: $budget) {
    id
  }
}
    `;
export type CreateProfileMutationFn = Apollo.MutationFunction<CreateProfileMutationPage, CreateProfileMutationVariables>;

/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutation, { data, loading, error }] = useCreateProfileMutation({
 *   variables: {
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      quiz: // value for 'quiz'
 *      budget: // value for 'budget'
 *   },
 * });
 */
export function useCreateProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateProfileMutationPage, CreateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProfileMutationPage, CreateProfileMutationVariables>(CreateProfileDocument, options);
      }
export type CreateProfileMutationHookResult = ReturnType<typeof useCreateProfileMutation>;
export type CreateProfileMutationResult = Apollo.MutationResult<CreateProfileMutationPage>;
export type CreateProfileMutationOptions = Apollo.BaseMutationOptions<CreateProfileMutationPage, CreateProfileMutationVariables>;
export const JoinCompanyDocument = gql`
    mutation JoinCompany($uuid: String!) {
  setWizardFinished {
    id
  }
  createFreeSubscription
  joinCompany(uuid: $uuid) {
    id
    uuid
    name
    tokens {
      id
      provider
    }
  }
}
    `;
export type JoinCompanyMutationFn = Apollo.MutationFunction<JoinCompanyMutationPage, JoinCompanyMutationVariables>;

/**
 * __useJoinCompanyMutation__
 *
 * To run a mutation, you first call `useJoinCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCompanyMutation, { data, loading, error }] = useJoinCompanyMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useJoinCompanyMutation(baseOptions?: Apollo.MutationHookOptions<JoinCompanyMutationPage, JoinCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCompanyMutationPage, JoinCompanyMutationVariables>(JoinCompanyDocument, options);
      }
export type JoinCompanyMutationHookResult = ReturnType<typeof useJoinCompanyMutation>;
export type JoinCompanyMutationResult = Apollo.MutationResult<JoinCompanyMutationPage>;
export type JoinCompanyMutationOptions = Apollo.BaseMutationOptions<JoinCompanyMutationPage, JoinCompanyMutationVariables>;